import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, Flex, Heading, Text } from '@radix-ui/themes';
import HashShortener from '../../components/HashShortener';
import InstrumentationChipGroup from '../../components/InstrumentationChip/InstrumentationChipGroup';
import InstrumentationPanel from '../../components/InstrumentationChip/InstrumentationPanel';
import { ChipType } from '../../components/InstrumentationChip';

const ContractDetail: React.FC = () => {
  const { address } = useParams<{ address: string }>();

  // Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState<ChipType>('list');

  // TODO: Fetch actual instrumentation coverage from API
  // Using placeholder counts to show the chips with data
  const coverage = { lists: 1, alerts: 2, workflows: 1 };

  const openDialog = (type: ChipType) => {
    setDialogType(type);
    setDialogOpen(true);
  };

  const handleListsClick = () => openDialog('list');
  const handleAlertsClick = () => openDialog('alert');
  const handleWorkflowsClick = () => openDialog('workflow');

  return (
    <Box p="2">
      <Heading size="6" mb="3">
        Contract Detail
      </Heading>
      {address && (
        <Card mb="4">
          <Flex direction="column" gap="3">
            <Flex justify="between" align="start" wrap="wrap" gap="3">
              <Box>
                <Text size="1" color="gray" mb="1">
                  Contract Address
                </Text>
                <HashShortener hash={address} />
              </Box>
            </Flex>
            <Box>
              <Text size="1" color="gray" mb="2">
                Automation Coverage
              </Text>
              <InstrumentationChipGroup
                coverage={coverage}
                showAddChips
                onListsClick={handleListsClick}
                onAlertsClick={handleAlertsClick}
                onWorkflowsClick={handleWorkflowsClick}
              />
            </Box>
          </Flex>
        </Card>
      )}
      <Text size="2" color="gray">
        This page will display detailed information about a specific contract
        including its ABI, deployment details, and transaction history.
      </Text>

      {/* Instrumentation Panel */}
      {address && (
        <InstrumentationPanel
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          type={dialogType}
          entityAddress={address}
        />
      )}
    </Box>
  );
};

export default ContractDetail;
